export const GET_STAGE_3_BROKEN_TEETH_RESULT = "GET_STAGE_3_BROKEN_TEETH_RESULT";
export const GET_STAGE_3_BROKEN_TEETH_RESULT_SUCCESS = "GET_STAGE_3_BROKEN_TEETH_RESULT_SUCCESS";
export const GET_STAGE_3_BROKEN_TEETH_RESULT_ERROR = "GET_STAGE_3_BROKEN_TEETH_RESULT_ERROR";
export const RESET_STAGE_3_BROKEN_TEETH_RESULT = "RESET_STAGE_3_BROKEN_TEETH_RESULT";
